export async function get_form_url(formName: string): Promise<{ submitAddr: string } | null> {
  if (formName === '贝勒漫画 联系我们') {
    return { submitAddr: 'https://readdy.ai/api/form/d9oncd0senbniolesi8g' };
  }
  return null;
}